import React from "react";
import RouterCont from "./containers/routerCont/routerCont";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import axios from "axios";

const theme = createTheme({
  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },
});

function App() {
  axios.defaults.withCredentials = true

  return (
    <ThemeProvider theme={theme}>
      <RouterCont />
    </ThemeProvider>
  );
}

export default App;
